import {
  Box,
  Button,
  // Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  AutoCompleteField,
  SearchInputFiled,
  SelectField,
} from "forms/hoc/formfield";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import React from "react";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import { useAppSelector } from "store/store";

const MainContainerWrapper = ({
  children,
  ...props
}: React.PropsWithChildren<MainContainerWrapperType>) => {
  const {
    handleClick,
    search,
    handleSearch,
    headingText,
    buttonText,
    buttonIcon,
    isSearch = false,
    isCreateButton = false,
    bgColor,
    searchPlaceHolder,
    buttonBgColor,
    handleSearchClear,
    selectOptions,
    isDriverMap,
    filterPlaceHolder="",
    isSelect,
    select_name,
    filter,
    setUpdateValue,
    filterList,
    isFilter,
    handleBack,
    px= { md: 2, xs: 0 },
    isBackButton = false ,
  } = props;
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: { xs: 1, md: 2, lg: 1 },
        px: px,
        // background: "white",
        // mt: 1,
        // mb: 2
      }}
    >
      {headingText && (
        <Stack
          direction={matchDownMD ? "column" : "row"}
          alignItems="center"
          sx={{
            justifyContent: { md: "space-between", xs: "center" },
            // rowGap: { xs: ".5rem" },
            minHeight: { xs: "3rem", md: "2rem", lg: "2rem" },
            height: { lg: "50px", xs: "90px", md: "90px" },
          }}
        >
          {headingText && (
            <Stack
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              {/* <Box> */}
              <Box 
                display="flex" 
                alignItems="center"
              >
                {isBackButton && <Box
                  onClick={() => handleBack?handleBack() : navigate(-1)} 
                  sx={{ cursor: "pointer", display: "flex", alignItems: "center", mr: 1 }}
                >
                  <KeyboardBackspaceIcon /> 
                </Box>}
              {/* </Box> */}
                <Typography variant="h2">{headingText}</Typography>
              </Box>
              {isSelect && (
                <Box sx={{ width: "250px", pl: 2 }}>
                  <SelectField
                    values={search}
                    handleChange={
                      handleSearch ? handleSearch : (e) => console.log("e", e)
                    }
                    placeholder={searchPlaceHolder || ""}
                    errors={null}
                    name={select_name || ""}
                    options={selectOptions || []}
                    id={select_name}
                  />
                </Box>
              )}
            </Stack>
          )}
          <Box>
            <Stack
              direction={matchDownMD ? "column-reverse" : "row"}
              spacing={matchDownMD ? 1 : 3}
              sx={
                {
                  rowGap: { xs: ".2rem" },
                }
              }
            >
              {isCreateButton && (
                <Button
                  className="createBtn"
                  variant="contained"
                  onClick={handleClick}
                  disableRipple
                  sx={{
                    height: "3.2rem",
                    padding: "1.5rem",
                    backgroundColor: theme.palette.primary?.createButtonColor,
                    
                    "&:hover": {
                      backgroundColor: theme.palette.primary?.createButtonColor,
                    },
                    color: {
                      xs: "white",
                      md: "white",
                      lg: "white",
                    },
                    
                  }}
                  startIcon={buttonIcon}
                >
                  {buttonText}
                </Button>
              )}
              {isDriverMap && (
                <Button
                  className="createBtn"
                  variant="contained"
                  onClick={handleClick}
                  disableRipple
                  sx={{
                    height: "3.1rem",
                    padding: "0 1rem",
                    backgroundColor:
                      buttonBgColor || theme.palette.primary?.createButtonColor,
                    "&:hover": {
                      backgroundColor:
                        buttonBgColor ||
                        theme.palette.primary?.createButtonColor,
                    },
                  }}
                  // startIcon={buttonIcon}
                >
                  Select Driver<span style={{ fontSize: ".65rem" }}>(s)</span>
                </Button>
              )}
              {isSearch && (
                <SearchInputFiled
                  values={search}
                  handleChange={handleSearch}
                  startIcon={<SearchIcon />}
                  endIcon={<Close />}
                  placeholder={searchPlaceHolder ? searchPlaceHolder : "Search"}
                  handleSearchClear={handleSearchClear}
                  // errors={
                  //   search && search.length < 3
                  //     ? "Please enter at least 3 characters"
                  //     : null
                  // }
                />
              )}
              {isFilter && (
                
                <Box 
                sx={{
                  width:{
                   sm:"10rem",
                   md:"20rem",
                   lg:"20rem",                   
                  }
                }}
                >
                  <AutoCompleteField
                    placeholder={filterPlaceHolder}
                    isRequired={false}
                    values={filter || null}
                    name="type"
                    handleChange={(type: any) => setUpdateValue(type)}
                    options={filterList}
                    id="type"
                  />
                
                </Box>
              )}
            </Stack>
          </Box>
        </Stack>
      )}
      <Box
        mt={2}
        // mb={4}
        sx={{
          width: "100%",
          minHeight: "76vh",
          // display: "flex",
          backgroundColor: bgColor ?? theme.palette.background.paper,
          // boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px 12px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

type MainContainerWrapperType = {
  handleClick?: (_: any) => void;
  search?: string | null;
  handleSearch?: (_: any) => void;
  headingText?: string;
  isSearch?: boolean;
  isCreateButton?: boolean;
  buttonText?: string;
  buttonIcon?: any;
  bgColor?: string;
  searchPlaceHolder?: string;
  buttonBgColor?: string;
  handleSearchClear?: (_: any) => void;
  isDriverMap?: boolean;
  buttonMapText?: string;
  isSelect?: boolean;
  selectOptions?: any[];
  select_name?: string;
  filter?: any;
  filterList?: any;
  isFilter?: boolean;
  setUpdateValue?: any;
  px?: any;
  filterPlaceHolder?: string;
  isBackButton?:boolean;
  handleBack?: () => void;
};

export default MainContainerWrapper;
